<div class="map-filter-line">
	<label>Map Filter: </label>
	<i class="glyphicons glyphicons-globe" [ngClass]="{'map-filter-on': isMapFilterOn, 'disabled-icon': isActionDisabled}" (click)="onToggleMapFilter()"></i>
</div>